<template>
  <div class="wrapper" :style="cssProps">
    <div class="loading">
      <pulse-loader
        :color="'#af7c00'"
        :size="'2em'"
        :loading="loading"
      ></pulse-loader>
    </div>
    <div class="header" v-if="!loading">
      <img :src="backIcon" @click="back" class="back" />
      <parkenda-menu class="menu"></parkenda-menu>
    </div>
    <div class="content" v-if="!loading">
      <div class="label">
        <p class="text">{{ this.$store.getters.TRANSLATIONS["payment"] }}</p>
      </div>
      <div class="content_title">
        {{ this.$store.getters.TRANSLATIONS["please_pay"] }} ${{
          this.$store.getters.TOTAL_AMOUNT
        }}
        {{ this.$store.getters.TRANSLATIONS["at_valet_stand"] }}
      </div>
    </div>
    <div class="footer" v-if="!loading">
      <button v-on:click="home()" class="button">
        {{ this.$store.getters.TRANSLATIONS["home"] }}
      </button>
    </div>
    <v-dialog style="margin-top: 25%" :width="350" />
    <parkenda-toolbar v-if="!loading"></parkenda-toolbar>
  </div>
</template>

<script>
export default {
  created: function () {
    if (!this.$storage.get("parkendaToken") || !this.$store.getters.USER) {
      this.$router.push("/login");
    }
  },
  beforeDestroy() {
    // clearInterval(this.timeInterval);
  },
  data() {
    return {
      loading: false,
      cssProps: {
        backgroundImage: `url(${require("@/assets/new_design/AdobeStock_317642058.png")})`,
        "background-position": "center",
        "background-repeat": "no-repeat",
        "background-size": "cover"
      },
      backIcon: require("@/assets/new_design/Polygon_3.png"),
      home: () => {
        this.$router.push("/appRating");
      },
      back: () => {
        this.$router.go(-1);
      }
    };
  }
};
</script>

<style scoped src="../../styles/main.css"></style>
<style scoped></style>



// WEBPACK FOOTER //
// src/components/RequestCar/PayWithValetStand.vue